import { render, staticRenderFns } from "./LC.vue?vue&type=template&id=0ab1522e"
import script from "./LC.vue?vue&type=script&lang=js"
export * from "./LC.vue?vue&type=script&lang=js"
import style0 from "./LC.vue?vue&type=style&index=0&id=0ab1522e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports